export default "__VITE_ASSET__D2F$T0TG__"